import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_DOMAIN } from '../../utils/constants';
import { comp_details, delete_report, fetch_report, get_layout, set_layout, set_record, update_record } from './inputConstant';
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_DOMAIN,
  prepareHeaders: (headers) => {
      console.log("Fetching API: Adding headers..."); // Debug log
      const token = localStorage.getItem('authToken');

      if (!token) {
          console.warn("No auth token found! API request may fail.");
          return headers; // Return headers without Authorization
      }

      headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', 'application/json');
      return headers;
  }
});

// A wrapper function to handle token verification and 401 errors
const baseQueryWithAuth = async (args, api, extraOptions) => {
  console.log("Executing baseQueryWithAuth with args:", args); // Debugging log

  const token = localStorage.getItem('authToken');

  if (!token) {
      console.warn("No auth token available. Redirecting to login...");
      window.location.href = "/login"; // Redirect if no token is present
      return { error: { status: 401, message: "Unauthorized - No Token" } };
  }

  const result = await baseQuery(args, api, extraOptions);

  console.log("API Response:", result);

  if (result?.error?.status === 401) {
      console.log("Unauthorized! Logging out...");
      
      // Remove token from localStorage
      localStorage.removeItem('authToken');

      // Redirect to login page
      window.location.href = "/login"; // Adjust based on routing

      // Optionally, dispatch a logout action to update Redux state
      // api.dispatch(logoutAction());
  }
  return result;
};


export const inputSlice = createApi({
    reducerPath: 'inputApi', // Unique name for the slice
    baseQuery:baseQueryWithAuth,
  //   baseQuery: fetchBaseQuery({ baseUrl: BASE_DOMAIN }), // Replace with your API base URL
    endpoints: (builder) => ({
      setsave: builder.mutation({
        query: (credentials) => ({
          url: set_layout, // Replace with your login endpoint
          method: 'POST',
          body: credentials,
        }),
      }),
      fetchreport: builder.query({
            query: (id) => {
              
              // Include the filter as query parameters
              // const queryString = new URLSearchParams(filter).toString();
              return {
                url: `${fetch_report}/${id}`, // Append query params to the endpoint
                method: 'GET',
                keepUnusedDataFor: 0,
              };
            },
          }),

      deletereport: builder.mutation({
            query: (id) => ({
              url: `${delete_report}/${id}`, // Append the company ID to the endpoint
              method: 'DELETE', // Use the DELETE method
            }),
          }),
      getapi: builder.query({
            query: (id) => {
                console.log("ID",id)
              // Include the filter as query parameters
              return {
                url: `${get_layout}${id}`, // Append query params to the endpoint
                method: 'GET',
              };
            },
          }),
          
      compapi: builder.query({
            query: (id) => {
                console.log("ID",id)
              // Include the filter as query parameters
              return {
                url: `${comp_details}/${id}`, // Append query params to the endpoint
                method: 'GET',
              };
            },
          }),
      setrecord: builder.mutation({
            query: (credentials) => ({
              url: set_record, // Replace with your login endpoint
              method: 'POST',
              body: credentials,
            }),
          }),
          updateRecord: builder.mutation({
            query: ({id,payload}) => ({
              url: `${update_record}/${id}`, // Replace with your login endpoint
              method: 'PUT',
              body: payload,
            }),
        
    }),
    })

});

export const { useSetsaveMutation,useGetapiQuery,useSetrecordMutation,useFetchreportQuery,useDeletereportMutation,useUpdateRecordMutation,useCompapiQuery } = inputSlice